import { solarRowSpacingModeMap } from '@payaca/gql-helpers';

import {
  type AccountSolarSettingsFieldsFragment,
  type SolarPlacementRulesInput,
} from '@/gql/graphql';
import { changedFields } from '@/utils/changedFields';
import { type EditablePlacementRules } from './PlacementRulesFields';

type GqlPlacementRules = AccountSolarSettingsFieldsFragment['placementRules'];

export const placementRulesFromGql = ({
  flatRoof: { rowSpacingMode, fixedClearGapM, ...flatRoof },
  ...rules
}: GqlPlacementRules): EditablePlacementRules => ({
  ...rules,
  flatRoof: {
    ...flatRoof,
    rowSpacingMode: solarRowSpacingModeMap.fromGql[rowSpacingMode],
    ...(fixedClearGapM != null && { fixedClearGapM }),
  },
});

export const changedPlacementRules = (
  initial: EditablePlacementRules,
  next: EditablePlacementRules
): SolarPlacementRulesInput => {
  const { flatRoof: initialFlatRoof, ...initialRules } = initial;
  const { flatRoof: nextFlatRoof, ...nextRules } = next;
  const changed = changedFields(initialRules, nextRules);
  const flatRoofChanges = changedFields(initialFlatRoof, nextFlatRoof);
  if (Object.keys(flatRoofChanges).length === 0) return changed;
  return {
    ...changed,
    flatRoof: {
      ...flatRoofChanges,
      rowSpacingMode:
        flatRoofChanges.rowSpacingMode &&
        solarRowSpacingModeMap.toGql[flatRoofChanges.rowSpacingMode],
    },
  };
};
